module.exports = __webpack_public_path__ + "2e9300d64a05136109a11b96c0c1c92c.pdf";